import { OrderActivityLog } from 'types/OrderActivityLog'
import moment from 'moment'
import { shouldDisplayAsByBoralAccordingToType } from './should-display-as-by-boral'
import { UserProfile } from 'types/UserProfile'
import { ORDER_ACTIVITY_LOG_TIME_FORMAT } from '../parts/ActivityLogItemContainerComp'
import { OrderActivityType } from 'types/OrderActivityTypes.enum'

export function getOrderActivityLogSubText(log: OrderActivityLog, userInfo: UserProfile) {
  const timeText = moment(log.createdDate).format(ORDER_ACTIVITY_LOG_TIME_FORMAT)
  let actionBy = `${log.firstName} ${log.lastName}`
  if (shouldDisplayAsByBoralAccordingToType(log.type)) {
    actionBy = `Boral`
  } else if (userInfo.id === log.userId) {
    actionBy = `you`
  }
  const subText = `${getActionTextBeforeBy(log.type)} by ${actionBy} at ${timeText}`
  return subText
}

const getActionTextBeforeBy = (actionType: OrderActivityType) => {
  const mapping = {
    ORDER_ACCEPTED: `Accepted`,
    ORDER_PROCESSING: `Processing`,
    ORDER_CREATED: `Created`,
    ORDER_CANCELLED: `Cancellation`,
    ORDER_CONFIRMED: `Confirmation`,
    ORDER_MODIFICATION_ACCEPTED: `Modified`,
    ORDER_MODIFICATION_CREATED: `Submitted`,
    ORDER_MODIFICATION_PROCESSING: `Processing`,
    ORDER_MODIFICATION_ACCEPTED_WITH_CONSULT: `Modified`,
    ORDER_MODIFICATION_REJECTED: `Processed`,
    ORDER_PLUS_LOAD_CREATED: `Submitted`,
    ORDER_PLUS_LOAD_APPLIED: `Processed`,
    ORDER_PLUS_LOAD_REJECTED: `Removed`,
  }
  return mapping[actionType]
}
